export const intro = [
  {
    intro: `I am a Full Stack Developer stuck in the body of a CPA. After 12 years as an accounting professional, 
      I decided to pursue what brings me joy and fulfillment: coding, problem solving, and building stuff.`,
    introElaborate:`I am a Full Stack Developer stuck in the body of a CPA. After 11 years as an accounting professional, 
      I decided to pursue what brings me joy and fulfillment: coding, problem solving, and building stuff.
      Besides coding, some of my interests include reading, music, sports (fantasy and otherwise), motorcycles, 
      trying to make people laugh, striving to be a better father and husband, and becoming a better person.`
  }
]

export const aboutMe = [
  { 
    id: 1,
    para: "Hi, I’m Juan Baltazar.",
  },
  {
    id:2,
    para: `I have been working as an accountant for the last 13 years. I have 
    been coding off and on, on my spare time, for the last 2 years. I would 
    like to change careers into the technology field. I took a full stack
    program at Thinkful (https://www.thinkful.com) and I know Javascript, HTML,
    CSS, PostgreSQL, Node.js, and React.js. I would like to gain more knowledge
    and experience to be proficient enough to pursue this as my profession.`,
  },
  {
    id:3,
    para: `I have the ability to learn and solve problems on my own.
    I am able to adapt and I am curious as to how things work. I love learning
    new things and I have plenty of experience working across all departments
    and with many different types of people. I also have great time management
    skills and experience with managing and leading a team.`,
  },
  {
    id:4,
    para: `Besides coding, some of my interests include reading, meditating,
    music, sports (fantasy and otherwise), motorcycles, trying to make people
    laugh, and being a father to an amazing girl.`,
  }
]

export const projects = [
  {
    id: 1,
    date_completed: '8/21/2019',
    title: "Dodgers Trivia",
    description: "A short quiz about the Los Angeles Dodgers",
    Tech: [ 
      {
        name: 'JavaScript',
        url: 'https://i.ibb.co/VpLZC4b/icons8-javascript-50.png',
      },
      {
        name: 'HTML',
        url: 'https://i.ibb.co/xqp2PjK/icons8-html-50.png',
      },
      {
        name: 'CSS',
        url: 'https://i.ibb.co/kQTT2kx/icons8-css-50.png',
      },
      {
        name: 'jQuery',
        url: 'https://i.ibb.co/8X0jhXM/icons8-jquery-50.png',
      }
    ],
    imageSource: "https://i.ibb.co/LRqW1Sp/Dodgers-App-Screen-Shot.png",
    imageAlt: "Screenshot of Juan Baltazar's web app about Dodgers trivia.",
    projectURL: "https://tubidaor.github.io/quiz-app/",
    projectRepoClient: "https://github.com/Tubidaor/quiz-app",
    projectRepoServer: "None"
  },
  {
    id: 2,
    date_completed: '9/29/2019',
    title: "Video Game Discovery",
    description: "Discover video games: past and present",
    Tech: [ 
      {
        name: 'JavaScript',
        url: 'https://i.ibb.co/VpLZC4b/icons8-javascript-50.png',
      },
      {
        name: 'HTML',
        url: 'https://i.ibb.co/xqp2PjK/icons8-html-50.png',
      },
      {
        name: 'CSS',
        url: 'https://i.ibb.co/kQTT2kx/icons8-css-50.png',
      },
      {
        name: 'jQuery',
        url: 'https://i.ibb.co/8X0jhXM/icons8-jquery-50.png',
      }
    ],
    imageSource: "https://gist.githubusercontent.com/Tubidaor/f2fa6d8791e90ee911b3399a80fd5527/raw/1efcaaa80d73e4f3740c64be8190250b4f96ed8b/Discovery%2520App%2520320vp.png",
    imageAlt: "Screenshot of Video Game Discovery App.",
    projectURL: "https://tubidaor.github.io/VideoGameDiscovery/",
    projectRepoClient: "https://github.com/Tubidaor/VideoGameDiscovery",
    projectRepoServer: "None"
  },
  {
    id: 3,
    date_completed: '4/20/2020',
    title: "Chatter",
    description: "Keep track of child's word count",
    Tech:
      [
        {
          name: 'React',
          url:  'https://i.ibb.co/mRvKjFm/icons8-react-50.png',
        },
        {
          name: 'Node',
          url: 'https://i.ibb.co/C77d9SM/icons8-nodejs-50.png',
        },
        {
          name: 'JavaScript',
          url: 'https://i.ibb.co/VpLZC4b/icons8-javascript-50.png',
        },
        {
          name: 'HTML',
          url: 'https://i.ibb.co/xqp2PjK/icons8-html-50.png',
        },
        {
          name: 'CSS',
          url: 'https://i.ibb.co/kQTT2kx/icons8-css-50.png',
        },
        {
          name: 'jQuery',
          url: 'https://i.ibb.co/8X0jhXM/icons8-jquery-50.png',
        },
        {
          name: 'PostgreSQl',
          url: 'https://i.ibb.co/SX68p6g/icons8-postgresql-50.png'
        }
      ],
    imageSource: "https://i.ibb.co/bQVZxkD/Chatter-App-Screen-Shot.png",
    imageAlt: "Screenshot of Chatter App.",
    projectURL: "https://chatter-app.juanbaltazar.now.sh/",
    projectRepoClient: "https://github.com/Tubidaor/chatter-app",
    projectRepotServer: "https://github.com/Tubidaor/chatter-server"
  },
  {
    id: 4,
    date_completed: '6/06/2020',
    title: "John Conway's Game of Life",
    description: "The Game of Life built with React",
    Tech:
      [
        {
          name: 'React',
          url:  'https://i.ibb.co/mRvKjFm/icons8-react-50.png',
        },
        {
          name: 'JavaScript',
          url: 'https://i.ibb.co/VpLZC4b/icons8-javascript-50.png',
        },
        {
          name: 'HTML',
          url: 'https://i.ibb.co/xqp2PjK/icons8-html-50.png',
        },
        {
          name: 'CSS',
          url: 'https://i.ibb.co/kQTT2kx/icons8-css-50.png',
        }
      ],
    imageSource: "https://i.ibb.co/DLfBXWt/Screenshot-2020-06-05-John-Conway-s-Game-of-Life-1.png",
    imageAlt: "Screenshot of Game of Life.",
    projectURL: "https://tubidaor.github.io/gameOfLife/",
    projectRepoClient: "https://github.com/Tubidaor/gameOfLife",
    projectRepoServer: "None"
  },
  {
    id: 5,
    date_completed: '10/25/2020',
    title: "Te Quiero Mucho",
    description: "An app for journaling, mood, and relationship tracking.",
    Tech:
      [
        {
          name: 'React',
          url:  'https://i.ibb.co/mRvKjFm/icons8-react-50.png',
        },
        {
          name: 'Node',
          url: 'https://i.ibb.co/C77d9SM/icons8-nodejs-50.png',
        },
        {
          name: 'JavaScript',
          url: 'https://i.ibb.co/VpLZC4b/icons8-javascript-50.png',
        },
        {
          name: 'HTML',
          url: 'https://i.ibb.co/xqp2PjK/icons8-html-50.png',
        },
        {
          name: 'CSS',
          url: 'https://i.ibb.co/kQTT2kx/icons8-css-50.png',
        },
        {
          name: 'jQuery',
          url: 'https://i.ibb.co/8X0jhXM/icons8-jquery-50.png',
        },
        {
          name: 'PostgreSQl',
          url: 'https://i.ibb.co/SX68p6g/icons8-postgresql-50.png'
        }
      ],
    imageSource: "https://i.ibb.co/Dp6h1st/TQMCover.png",
    imageAlt: "Screenshot of Te Quiero Mucho App.",
    projectURL: "https://te-quiero-mucho-app.juanbaltazar.vercel.app/",
    projectRepoClient: "https://github.com/Tubidaor/te-quiero-mucho-client",
    projectRepoServer: "https://github.com/Tubidaor/teQuieroMuchoServer"
  },
  {
    id: 6,
    date_completed: '11/30/2020',
    title: "Find the Letter",
    description: "A random maze generator and a way to learn ABC's.",
    Tech:
      [
        {
          name: 'React',
          url:  'https://i.ibb.co/mRvKjFm/icons8-react-50.png',
        },
        {
          name: 'JavaScript',
          url: 'https://i.ibb.co/VpLZC4b/icons8-javascript-50.png',
        },
        {
          name: 'HTML',
          url: 'https://i.ibb.co/xqp2PjK/icons8-html-50.png',
        },
        {
          name: 'CSS',
          url: 'https://i.ibb.co/kQTT2kx/icons8-css-50.png',
        },
      ],
    imageSource: "https://i.ibb.co/fFrXsX1/Screenshot-2020-12-02-Random-maze-generator.png",
    imageAlt: "Screenshot of Random Maze Generator App.",
    projectURL: "https://maze-beryl.vercel.app/",
    projectRepoClient: "https://github.com/Tubidaor/mazerunner",
    projectRepoServer: "None"
  },
  {
    id: 7,
    date_completed: '6/1/2021',
    title: "StockChef",
    description: `A shopping list and inventory management app that gives you
      recipes based on what you have in stock.`,
    Tech:
      [
        {
          name: 'React',
          url:  'https://i.ibb.co/mRvKjFm/icons8-react-50.png',
        },
        {
          name: 'JavaScript',
          url: 'https://i.ibb.co/VpLZC4b/icons8-javascript-50.png',
        },
        {
          name: 'HTML',
          url: 'https://i.ibb.co/xqp2PjK/icons8-html-50.png',
        },
        {
          name: 'CSS',
          url: 'https://i.ibb.co/kQTT2kx/icons8-css-50.png',
        },
        {
          name: 'Node',
          url: 'https://i.ibb.co/C77d9SM/icons8-nodejs-50.png',
        },
        {
          name: 'PostgreSQl',
          url: 'https://i.ibb.co/SX68p6g/icons8-postgresql-50.png'
        }
      ],
    imageSource: "https://i.ibb.co/0spdZtw/Screen-Shot-2021-07-17-at-9-08-43-AM.png.png",
    imageAlt: "Screenshot of StockChef App.",
    projectURL: "https://stockchef.vercel.app/",
    projectRepoClient: "https://github.com/Tubidaor/im-hungry",
    projectRepoServer: "https://github.com/Tubidaor/im-hungry-server"
  },
  {
    id: 8,
    date_completed: '7/31/2021',
    title: "Connect 4",
    description: `The classic game, Connect 4, with React.`,
    Tech:
      [
        {
          name: 'React',
          url:  'https://i.ibb.co/mRvKjFm/icons8-react-50.png',
        },
        {
          name: 'JavaScript',
          url: 'https://i.ibb.co/VpLZC4b/icons8-javascript-50.png',
        },
        {
          name: 'HTML',
          url: 'https://i.ibb.co/xqp2PjK/icons8-html-50.png',
        },
        {
          name: 'CSS',
          url: 'https://i.ibb.co/kQTT2kx/icons8-css-50.png',
        }
      ],
    imageSource: "https://i.ibb.co/RjnwZbd/Screen-Shot-2021-08-01-at-10-03-30-PM.png",
    imageAlt: "Screenshot of Connect 4 app.",
    projectURL: "https://connect-four-three.vercel.app/",
    projectRepoClient: "https://github.com/Tubidaor/connect-four",
    projectRepoServer: "None"
  },
]

export default {
  intro,
  aboutMe,
  projects,
}